import { MobiDocument } from './MobiDocument';

export class PaletteCategorieActiviteDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private palette_id: number;
    private categorieactivite_nom: string;

    public constructor(palettecat: any) {
        super()
        this._id = palettecat._id;
        this._rev = palettecat._rev;
        this.id = palettecat.id;
        this.palette_id = palettecat.palette_id;
        this.categorieactivite_nom = palettecat.categorieactivite_nom;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getPalette_id(): number {
        return this.palette_id;
    }

    public setPalette_id(palette_id: number): void {
        this.palette_id = palette_id;
    }

    public getCategorieactivite_nom(): string {
        return this.categorieactivite_nom;
    }

    public setCategorieactivite_nom(categorieactivite_nom: string): void {
        this.categorieactivite_nom = categorieactivite_nom;
    }
}